<template>
    <div class="FormBlockBuilder">
        <div class="row">
            <div class="col-6">
                <h2>Edit:</h2>
                <div class="form-group">
                    <select class="form-control" v-model="NewBlockSelection">
                        <option v-for="(value, propertyName) in BlockSchema" :value="propertyName">{{ value.Title }}</option>
                    </select>
                    <button class="form-control btn btn-success" @click="AppendNewElement">Append New Element</button>
                </div>
            </div>
            <div class="col-6">
                <h2>Preview:</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-6 scroller-div">
                <FormBlock :form-block-item="FormBlockData" :input-values="{}" :editor="true" />
            </div>
            
            <div class="col-6 scroller-div">
                <b-form @submit="TestSubmit" ref="PreviewForm" class="form-interior">
                    <FormBlock :form-block-item="FormBlockData" :input-values="{}" />
                    <br /><br />
                    <b-button variant="success" type="button" @click="TestValues" block>TEST VALUES</b-button>
                    <b-button variant="success" type="submit" block>TEST VALIDATION</b-button>
                    <b-button variant="warning" type="button" @click="ResetForm" block>RESET FORM VALUES</b-button>
                    <br />
                    <input class="form-control" v-model="FormBlockExportBox" type="text" />
                    <b-button variant="success" type="button" @click="ExportForm" block>EXPORT FORM</b-button>
                    <br />
                    <input class="form-control" v-model="FormBlockImportBox" type="text" />
                    <b-button variant="success" type="button" @click="ImportForm" block>IMPORT FORM</b-button>

                </b-form>
            </div>
            
        </div>
    </div>

</template>

<script>
    import { EventBus } from '../../../services/event-bus.js';
    import FormBlock from '../RecordComponents/FormBlock.vue'

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowUp);
    import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowDown);

    export default {
        created: function () {
            let vm = this;
            EventBus.$on('form-block-radio-change', formBlockItem => {
                vm.ActiveBlock = formBlockItem;
            });
            EventBus.$on('form-block-check-change', formBlockItem => {
                vm.ActiveBlock = formBlockItem;
            });
        },
        beforeDestroy() {
            EventBus.$off('form-block-radio-change');
            EventBus.$off('form-block-check-change');
        },
        props: [],
        data: function () {
            return {
                NewBlockSelection: "",
                FormBlockImportBox: "",
                FormBlockExportBox: "",
                FormBlockData: {
                    BlockType: "Container",
                    ContainerType: "ElementContainer",
                    ChildBlocks: [],
                    Active: true,
                    Title: "Container: Element Container",
                    Index: 0
                },
                ActiveBlock: {},
                BlockSchema: {
                    "ElementContainer": {
                        Title: "Container: Element Container",
                        Active: "",
                        BlockType: "Container",
                        ContainerType: "ElementContainer",
                        ChildBlocks: [],
                    },
                    "RowWithChildPerColumn": {
                        BlockType: "Container",
                        ContainerType: "RowWithChildPerColumn",
                        Title: "Container: Row with Child per Column",
                        Active: "",
                        ChildBlocks: []
                    },
                    "Fieldset": {
                        BlockType: "Container",
                        ContainerType: "Fieldset",
                        Title: "Container: Fieldset",
                        Active: "",
                        Legend: "Fieldset Legend",
                        ChildBlocks: []
                    },
                    "H1": {
                        Title: "H1",
                        BlockType: "InputElement",
                        ElementType: "H1",
                        Value: "H1 Text",
                        Active: ""
                    },
                    "H2": {
                        Title: "H2",
                        BlockType: "InputElement",
                        ElementType: "H2",
                        Value: "H2 Text",
                        Active: ""
                    },
                    "H3": {
                        Title: "H3",
                        BlockType: "InputElement",
                        ElementType: "H3",
                        Value: "H3 Text",
                        Active: ""
                    },
                    "H4": {
                        Title: "H4",
                        BlockType: "InputElement",
                        ElementType: "H4",
                        Value: "H4 Text",
                        Active: ""
                    },
                    "Paragraph": {
                        Title: "Paragraph",
                        BlockType: "InputElement",
                        ElementType: "P",
                        Value: "Paragraph Text",
                        Active: ""
                    },
                    "StringInput": {
                        Title: "Text Input",
                        BlockType: "InputElement",
                        ElementType: "StringInput",
                        Required: false,
                        Label: "Text Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Placeholder: ""
                    },
                    "IntegerInput": {
                        Title: "Number Input",
                        BlockType: "InputElement",
                        ElementType: "IntegerInput",
                        Required: false,
                        Label: "Number Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Placeholder: ""
                    },
                    "StringInputNoLabel": {
                        Title: "Text Input (No Label)",
                        BlockType: "InputElement",
                        ElementType: "StringInputNoLabel",
                        Required: false,
                        Name: "",
                        Class: "",
                        Active: "",
                        Placeholder: ""
                    },
                    "DateInput": {
                        Title: "Date Input",
                        BlockType: "InputElement",
                        ElementType: "DateInput",
                        Required: false,
                        Label: "Date Input",
                        Name: "",
                        Class: "",
                        Active: ""
                    },
                    "TimeInput": {
                        Title: "Time Input",
                        BlockType: "InputElement",
                        ElementType: "TimeInput",
                        Required: false,
                        Label: "Time Input",
                        Name: "",
                        Class: "",
                        Active: ""
                    },
                    "TextAreaInput": {
                        Title: "Text Area Input",
                        BlockType: "InputElement",
                        ElementType: "TextAreaInput",
                        Required: false,
                        Label: "Text Area Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Rows: 4
                    },
                    "TextAreaAutosizeInput": {
                        Title: "Autosize Input",
                        BlockType: "InputElement",
                        ElementType: "TextAreaAutosizeInput",
                        Required: false,
                        Label: "Autosize Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        BaseHeight: 100,
                        MaxHeight: 5000,
                        Placeholder: "",
                        BaseContent: ""
                    },
                    "SelectInput": {
                        Title: "Select Input",
                        BlockType: "InputElement",
                        ElementType: "SelectInput",
                        Required: false,
                        Label: "Select Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        SelectOptions: [
                            {
                                text: "Option A",
                                value: "OptionA",
                                selected: false,
                                hidden: false
                            },
                            {   
                                text: "Option B",
                                value: "OptionB",
                                selected: false,
                                hidden: false
                               
                            },
                            {
                                text: "Option C",
                                value: "OptionC",
                                selected: false,
                                hidden: false
                            }
                        ],
                    },
                    "RadioInput": {
                        Title: "Radio Input",
                        BlockType: "InputElement",
                        ElementType: "RadioInput",
                        Required: false,
                        Label: "Radio Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Stacked: false,
                        RadioOptions: [
                            {
                                text: "Option A",
                                value: "OptionA",
                                selected: false,
                            },
                            {   
                                text: "Option B",
                                value: "OptionB",
                                selected: false,
                               
                            },
                            {
                                text: "Option C",
                                value: "OptionC",
                                selected: false,
                            }
                        ],
                    },
                    "CheckInput": {
                        Title: "Check Input",
                        BlockType: "InputElement",
                        ElementType: "CheckInput",
                        Required: false,
                        Label: "Check Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Stacked: false,
                        CheckOptions: [
                            {
                                text: "Option A",
                                value: "OptionA",
                                selected: false,
                            },
                            {
                                text: "Option B",
                                value: "OptionB",
                                selected: false,

                            },
                            {
                                text: "Option C",
                                value: "OptionC",
                                selected: false,
                            }
                        ],
                    },
                    "CheckInputFromAPI": {
                        Title: "Check Input from API",
                        BlockType: "InputElement",
                        ElementType: "CheckInputFromAPI",
                        Required: false,
                        Label: "Check Input From API",
                        Name: "",
                        Class: "",
                        Active: "",
                        Stacked: false,
                        Endpoint: "",
                        CheckOptions: [
                            
                        ],
                    },
                    "ImageInput": {
                        Title: "Image Input",
                        BlockType: "InputElement",
                        ElementType: "ImageInput",
                        Required: false,
                        Label: "Image Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Placeholder: ""
                    },
                    "DocumentInput": {
                        Title: "Document Input",
                        BlockType: "InputElement",
                        ElementType: "DocumentInput",
                        Required: false,
                        Label: "Document Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Placeholder: ""
                    },
                    "ScanFileInput": {
                        Title: "Scan File Input",
                        BlockType: "InputElement",
                        ElementType: "ScanFileInput",
                        Required: false,
                        Label: "Scan File Input",
                        Name: "",
                        Class: "",
                        Active: "",
                        Placeholder: ""
                    },
                }
            };
        },
        methods: {
            AppendNewElement() {
                if (this.ActiveBlock.BlockType == "Container") {
                    //append to end of array
                    let newBlock = JSON.parse(JSON.stringify(this.BlockSchema[this.NewBlockSelection]));
                    newBlock.Index = this.ActiveBlock.ChildBlocks.length;
                    this.ActiveBlock.ChildBlocks.push(newBlock);
                    this.HTMLFormInput = JSON.stringify(this.FormBlockData);
                } else {
                    EventBus.$emit('transmission-error', ["You can only add a new element to a container type."]);
                }
            },
            ResetForm() {
                let form = this.$refs['PreviewForm'];
                form.reset();
            },
            TestSubmit(e) {
                e.preventDefault();
                this.TestValues();
            },
            TestValues() {
                let form = this.$refs['PreviewForm'];
                let formData = new FormData(form);
                console.log("FORM DATA:")
                for(var pair of formData.entries()) {
                   console.log(pair[0]+ ' = '+ pair[1]); 
                }
            },
            ExportForm() {
                this.FormBlockExportBox = JSON.stringify(this.FormBlockData);
                console.log(this.FormBlockExportBox);
            },
            ImportForm() {
                this.$set(this, 'FormBlockData', JSON.parse(this.FormBlockImportBox));
            },
            ImportFormFromExternalData(importData) {
                this.$set(this, 'FormBlockData', JSON.parse(importData));
            },
            ReturnExportForm() {
                return JSON.stringify(this.FormBlockData);
            },
            Save() {
                this.$MasterAPI.ExecuteRequest("POST", this.Endpoint, this.Payload, this.SaveSuccess, () => { }, true);

            },
            SaveSuccess(response) {
                this.$refs['component-modal'].hide();
                //emit success response
                this.$emit("success");
                //Perform Global Updates
                if (this.PerformGlobalUpdate) {
                    this.$GlobalUpdate.ExecuteGlobalUpdate();
                }
            }
        },
        components: {
            FormBlock
        },
        computed: {

        },
        mounted: function () {
            this.ActiveBlock = this.FormBlockData;
        }
    }
</script>

<style scoped>
    .scroller-div {
        overflow-y: scroll;
        height: 900px;
    }
</style>